import transform from 'lodash/transform';
import flatMap from 'lodash/flatMap';
import { useIntl } from 'react-intl';
import {
  ApplicationsListRaw,
  ApplicationsListEnhanced,
  ApplicationsListCategories,
  ApplicationInfoRaw,
  ApplicationInfo,
  AppId,
} from '../../ApplicationWrapper.types';
import { messages } from '../../i18n';
import { applicationsIdOrder, applicationsInfo } from './ApplicationsInfoMap.const';

export const enhanceApplicationsList = (applicationsByCategories: ApplicationsListRaw) => {
  const applications = flatMap(applicationsByCategories).filter(hasApplicationInfo);

  // TODO: Fix types
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return transform<AppId[], ApplicationsListEnhanced>(
    applicationsIdOrder,
    (acc, appIds, category: ApplicationsListCategories) => {
      acc[category] = acc[category] || [];

      appIds.forEach((appId: AppId) => {
        const application = applications.find(({ id }) => id === appId);
        if (application) {
          acc[category].push(getApplicationInfo(application));
        }
      });
    },
    {} as ApplicationsListEnhanced
  );
};

// new products can be added to the api payload without having the corresponding applicationsInfo object
// we'll only display products that we have an applicationsInfo object for them
const hasApplicationInfo = (application: ApplicationInfoRaw): boolean => !!applicationsInfo[application.id];

const getApplicationInfo = (application: ApplicationInfoRaw): ApplicationInfo => ({
  ...applicationsInfo[application.id],
  active: application.active,
});

export const useApplicationInfo = (appId: AppId) => {
  const { formatMessage } = useIntl();
  const item = (applicationsInfo as Record<AppId, ApplicationInfo>)[appId];

  return {
    appIcon: item?.iconActive,
    appDisplayName: item?.name && formatMessage(messages[item.name]),
  };
};
